import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { signatureToHtml, isRichSignatureHtml, adaptSignatureHtmlForAppPreview } from "@/lib/compose/composeHtml";
import { cn } from "@/lib/cn";

type Props = {
  signature: string;
  /** Ouvert au montage (défaut : fermé). */
  defaultOpen?: boolean;
};

export function ComposeSignaturePreview({ signature, defaultOpen = false }: Props) {
  const [open, setOpen] = useState(defaultOpen);
  const signatureHtml = signatureToHtml(adaptSignatureHtmlForAppPreview(signature));
  if (!signatureHtml.trim()) return null;
  const rich = isRichSignatureHtml(signature);
  const panelId = "compose-signature-panel";

  return (
    <section className="compose-signature-accordion shrink-0" aria-label="Signature du message">
      <button
        type="button"
        className="compose-signature-accordion__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        <ChevronRight
          className={cn(
            "compose-signature-accordion__chevron h-3.5 w-3.5 shrink-0 transition-transform duration-200",
            open && "rotate-90"
          )}
          aria-hidden
        />
        <span className="compose-signature-accordion__title">Signature</span>
        <span className="compose-signature-accordion__hint">incluse à l&apos;envoi</span>
      </button>

      {open ? (
        <div
          id={panelId}
          className={cn(
            "compose-signature-accordion__panel mail-compose-signature mail-signature-preview-scope",
            rich && "mail-compose-signature--rich"
          )}
          dangerouslySetInnerHTML={{ __html: signatureHtml }}
        />
      ) : null}
    </section>
  );
}
